<template>
    <div class="row">
        <div class="col-md-4">
            <div class="feature-list-progress section-space--pt_60">
                <div class="feature-list-progress__counter">
                    <div class="circle-progress-wrapper">
                        <div class="chart-progress">
                            <div class="chart-progress__inner-wrapper">
                                <div class="chart-progress__inner">
                                    <vue-circle
                                        :progress="95"
                                        :size="160"
                                        line-cap="round"
                                        :fill="fill"
                                        :thickness="4"
                                        :start-angle="0"
                                        :show-percent="true">
                                    </vue-circle>
                                </div>
                            </div>
                        </div>
                        <div class="circle-design one"></div>
                        <div class="circle-design two"></div>
                    </div>
                </div>
                <div class="feature-list-progress__info">
                    <h6 class="feature-list-progress__title mb-20">オフィス</h6>
                    <ul class="feature-list-progress__list">
                        <li>13都市</li>
                        <li>新サブマーケットを創設</li>
                        <li>対象ビルのサンプル調査に基づく想定成約賃料</li>
                        <li>想定成約賃料</li>
                        <li>空室率</li>
                        <li>新規供給、 新規需要</li>
                        <li>新築・竣工予定物件</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="feature-list-progress section-space--pt_60">
                <div class="feature-list-progress__counter">
                    <div class="circle-progress-wrapper">
                        <div class="chart-progress">
                            <div class="chart-progress__inner-wrapper">
                                <div class="chart-progress__inner chart-progress__inner--green">
                                    <vue-circle
                                        :progress="85"
                                        :size="160"
                                        line-cap="round"
                                        :fill="blue"
                                        :thickness="4"
                                        :start-angle="0"
                                        :show-percent="true">
                                    </vue-circle>
                                </div>
                            </div>
                        </div>
                        <div class="circle-design circle-design--green one"></div>
                        <div class="circle-design circle-design--green two"></div>
                    </div>
                </div>
                <div class="feature-list-progress__info">
                    <h6 class="feature-list-progress__title mb-20">インダストリアル</h6>
                    <ul class="feature-list-progress__list">
                        <li>16都市</li>
                        <li>58エリア</li>
                        <li>募集賃料/li>
                        <li>実質賃料指数</li>
                        <li>実質賃料指数</li>
                        <li>空室率</li>
                        <li>新規供給、 新規需要</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="feature-list-progress section-space--pt_60">
                <div class="feature-list-progress__counter">
                    <div class="circle-progress-wrapper">
                        <div class="chart-progress">
                            <div class="chart-progress__inner-wrapper">
                                <div class="chart-progress__inner chart-progress__inner--blue">
                                    <vue-circle
                                        :progress="75"
                                        :size="160"
                                        line-cap="round"
                                        :fill="blue"
                                        :thickness="4"
                                        :start-angle="0"
                                        :show-percent="true">
                                    </vue-circle>
                                </div>
                            </div>
                        </div>
                        <div class="circle-design circle-design--blue one"></div>
                        <div class="circle-design circle-design--blue two"></div>
                    </div>
                </div>
                <div class="feature-list-progress__info">
                    <h6 class="feature-list-progress__title mb-20">インダストリアル</h6>
                    <ul class="feature-list-progress__list">
                        <li>リテール</li>
                        <li>5都市 東京、大阪、京都、神戸、名古屋</li>
                        <li>11エリア 銀座、表参道・原宿、新宿、渋谷、 梅田、心斎橋、難波、京都、神戸、名駅、栄</li>
                        <li>想定成約賃料</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueCircle from 'vue2-circle-progress/src/index.vue'

    export default {
        components: {
            VueCircle
        },
        data (){
            return {
                fill : { gradient: ["#fad961", "#f76b1c"] },
                blue : { gradient: ["#538184", "#003F2D"] },
                green : { gradient: ["#538184", "#003F2D"] },

            }
        }
    }
</script>